import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { SharedModule } from '../shared/shared.module';
import { PostLoginRoutingModule } from '../Post-Login/post-login-routing.module';
import { ProfileComponent } from '../Post-Login/profile/profile.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import {NgxPaginationModule} from 'ngx-pagination';
import { NgxStarsModule } from 'ngx-stars';
import { NgxSkeletonModule } from 'ngx-skeleton';
import { KycProfileComponent } from '../Post-Login/kyc-profile/kyc-profile.component';
import { TestDriveListComponent } from '../Post-Login/test-drive-list/test-drive-list.component';
import { UserProfileComponent } from '../Post-Login/user-profile/user-profile.component';
import { WishlistListComponent } from '../Post-Login/wishlist-list/wishlist-list.component';
import { ConfiguratorListComponent } from '../Post-Login/configurator-list/configurator-list.component';
import { BookingListComponent } from '../Post-Login/booking-list/booking-list.component';
import { DealerReviewComponent } from '../Post-Login/dealer-review/dealer-review.component';
import { VasDashboardComponent } from '../Post-Login/vas-dashboard/vas-dashboard.component';
import { FniJourneyComponent } from '../Post-Login/fni-journey/fni-journey.component';
import { RewardCenterComponent } from '../Post-Login/reward/reward-center/reward-center.component';
import { RewardGiftCardComponent } from '../Post-Login/reward/reward-gift-card/reward-gift-card.component'//'../Post-Login/reward/reward-gift-card/reward-gift-card.component';
import { RedeemRewardsComponent } from '../Post-Login/reward/redeem-rewards/redeem-rewards.component'//'../ost-Login/reward/redeem-rewards/redeem-rewards.component';
import { RewardStatementComponent } from '../Post-Login/reward/reward-statement/reward-statement.component';
import { RewardTermsConditionComponent } from '../Post-Login/reward/reward-terms-condition/reward-terms-condition.component';
import { TataokFniJourneyComponent } from './tataok-fni-journey/tataok-fni-journey.component';

@NgModule({
  declarations: [
    ProfileComponent,
    KycProfileComponent,TestDriveListComponent,UserProfileComponent,
    WishlistListComponent,ConfiguratorListComponent,BookingListComponent,UserProfileComponent,
    DealerReviewComponent,VasDashboardComponent, FniJourneyComponent,RewardCenterComponent,RewardGiftCardComponent,
    RedeemRewardsComponent,RewardStatementComponent,RewardTermsConditionComponent,TataokFniJourneyComponent
  ],
  imports: [
    CommonModule,
    PostLoginRoutingModule,NgxPaginationModule,NgxStarsModule,NgxSkeletonModule,
    SharedModule, FormsModule, ReactiveFormsModule,NgbModule
  ]
})
export class PostLoginModule { }
